import {
  type Options,
  postHostedOnboardingBack,
  postHostedOnboardingBackQueryKey,
  postHostedOnboardingProceed,
  postHostedOnboardingProceedQueryKey,
} from '@onefootprint/fetch-hosted';
import type { PostHostedOnboardingBackData, PostHostedOnboardingProceedData } from '@onefootprint/request-types';

// Stable query keys based only on the operation ID - body params don't affect caching
// Always uses empty body to ensure cache hits regardless of actual request body params
export const getProceedQueryKey = () => postHostedOnboardingProceedQueryKey({ body: {} });
export const getBackQueryKey = () => postHostedOnboardingBackQueryKey({});

// Custom options that use stable query key while preserving body for the actual request
// Note: We define a custom queryFn to avoid the generated one which spreads queryKey[0]
// over options, which would overwrite our body with the empty body from the stable query key
export const getStableProceedOptions = (options: Options<PostHostedOnboardingProceedData>) => {
  return {
    queryKey: getProceedQueryKey(),
    queryFn: async ({ signal }: { signal?: AbortSignal }) => {
      const { data } = await postHostedOnboardingProceed({
        ...options,
        signal,
        throwOnError: true,
      });
      return data;
    },
  };
};

export const getStableBackOptions = (options: Options<PostHostedOnboardingBackData>) => {
  return {
    queryKey: getBackQueryKey(),
    queryFn: async ({ signal }: { signal?: AbortSignal }) => {
      const { data } = await postHostedOnboardingBack({
        ...options,
        signal,
        throwOnError: true,
      });
      return data;
    },
  };
};
